import {
  UseQueryResult,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { type ImageSize } from '../../../../types/isomorphic';
import useApi from '../useApi';
import { DOWNLOAD_QUERY_KEYS } from './keys';

interface useDownloadImageSizesRequest {
  getDownloadSizes: (
    genRequestId: string,
    index: number
  ) => UseQueryResult<ImageSize[]>;
  invalidateDownloadSizes: (genRequestId: string, index: number) => void;
}

const useImageDownloadSizes = (): useDownloadImageSizesRequest => {
  const { downloadService } = useApi();
  const queryClient = useQueryClient();

  const getDownloadSizes = (
    genRequestId: string,
    index: number
  ): UseQueryResult<ImageSize[]> =>
    // calling useQuery here is safe as this method is only accessible by calling a hook
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useQuery({
      queryKey: DOWNLOAD_QUERY_KEYS.imageSizes(genRequestId, index),
      queryFn: async () => {
        if (!genRequestId) return [];
        const data = await downloadService.getImageDownloadSizes(
          genRequestId,
          index
        );
        return data;
      },
    });

  const invalidateDownloadSizes = (genRequestId: string, index: number) => {
    queryClient.invalidateQueries({
      queryKey: DOWNLOAD_QUERY_KEYS.imageSizes(genRequestId, index),
    });
  };

  return {
    getDownloadSizes,
    invalidateDownloadSizes,
  };
};

export default useImageDownloadSizes;
